import { Http } from '@angular/http';
import { MainService } from './../../services/main.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ClinicalUpdatesProvider {

  data: any;
  sortedData: any;
  organizedData: Array<any> = [];

  als: boolean = true;
  fr: boolean = true;
  aav: boolean = true;
  noResults: boolean = false;

  constructor(public http: Http, public mainService: MainService) {
    // console.log('init');
    
    let url = this.mainService.dataDirectory('clinical-updates.json');
    this.http
      .get(url)
      .map((res) => res.json())
      .subscribe((res) => {
        this.data = res;
        this.addISODate();
        //console.log(this.data);
        this.sortByKey(this.data, 'iso_date');
        this.organizeData(this.data);
        //console.log(this.data);
      });
  }

addISODate() {
  for(let i: number = 0; i < this.data.length; i++) {
    this.data[i].iso_date = this.data[i].version_date.split('/').reverse().join('/');
  }
}

sortByKey(array, key) {
  return array.sort(function (a, b) {
    var x = new Date(a[key]).getTime(); var y = new Date(b[key]).getTime();
    return (x < y) ? -1 : (x > y) ? 1 : 0;
  });
}

pad2(str): string {
	if(str.length === 2) {
		return str;
	}else{
		return `0${str}`;
	}
}

padYear(str): string {
	if(str.length === 2) {
		return `20${str}`;
	}else{
		return str;
	}
}

organizeData(data) {
	let dateData = {};

  for (let i: number = data.length - 1; i >= 0; i--) {
		let dateSplit = data[i].version_date.split('/');
		let date = `${this.padYear(dateSplit[2])}-${this.pad2(dateSplit[1])}-${this.pad2(dateSplit[0])}`;

		if(!dateData[date]) {
			dateData[date] = [];
		}

		dateData[date].push({
			"cpg_reference": data[i].cpg_reference,
			"cpg_reference2": this.normalizeCpgReference(data[i].cpg_reference),
			"version_number": data[i].version_number,
			"details": data[i].details,
			"title": data[i].cpg_name,
			"type": data[i].type,
			// "link": data[i].link,
			"hidden": false
		});
  }

	let dates = Object.keys(dateData).sort((a, b) => {
		let dateA = new Date(a);
		let dateB = new Date(b);
		return dateB.getTime() - dateA.getTime();
	});
	
	for(let date of dates) {
		let dateSplit = date.split('-');
		let dateFormat = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0]}`;

		this.organizedData.push({
			"date": dateFormat,
			"items": dateData[date]
		});
	}
}

normalizeCpgReference(ref) {
  let r = ref;
  r = r.trim();
  r = r.toLowerCase();
  r = r.split(' ').join('');
  //r = r.substring(0, r.indexOf('-'));
  //console.log(r);
  return r;

}

updateData() {
  // let loader = this.loading.create({
  //   spinner: 'ios'
  // });

  // loader.present();

  this.noResults = true;
  for (let i: number = 0; i < this.organizedData.length; i++) {
    for (let j: number = 0; j < this.organizedData[i].items.length; j++) {
      if (this.isRelevant(this.organizedData[i].items[j].cpg_reference)) {
        this.organizedData[i].items[j].hidden = false;
      }
      else {
        this.organizedData[i].items[j].hidden = true;
      }
    }
  }
  for (let i: number = 0; i < this.organizedData.length; i++) {
    for (let j: number = 0; j < this.organizedData[i].items.length; j++) {
      if (this.organizedData[i].items[j].hidden === false) {
        this.noResults = false;
        break;
      }
    }
  }
  //loader.dismiss();

  // console.log(this.organizedData);
}

isRelevant(ref): boolean {
  //console.log(this.als, this.fr, this.aav);
  //console.log(ref.search(/AAV/))
  if (this.als && this.fr && this.aav) {
    return true;
  }

  if (this.aav && ref.search(/AAV/) === 4) {
    return true;
  }

  if (this.als && ref.search(/CPG/) === 0 && ref.search(/AAV/) !== 4) {
    return true;
  }

  if (this.fr && ref.search(/CPP/) === 0) {
    return true;
  }

  return false;
}

allItemsHidden(item) {
  for (let i: number = 0; i < item.items.length; i++) {
    if (!item.items[i].hidden) {
      return true;
    }
  }

  return false;
}

filterForRef(ref) {
  this.noResults = true;
	let r = this.normalizeCpgReference(ref);

  for (let i: number = 0; i < this.organizedData.length; i++) {
    for (let j: number = 0; j < this.organizedData[i].items.length; j++) {
      if (this.organizedData[i].items[j].cpg_reference2 === r) {
        this.organizedData[i].items[j].hidden = false;
      }
      else {
        this.organizedData[i].items[j].hidden = true;
      }
    }
  }

  for (let i: number = 0; i < this.organizedData.length; i++) {
    for (let j: number = 0; j < this.organizedData[i].items.length; j++) {
      if (this.organizedData[i].items[j].hidden === false) {
        this.noResults = false;
        break;
      }
    }
  }
}

reset() {
  // this.ref = undefined;
  this.organizedData = [];
  this.organizeData(this.data);
  this.als = true;
  this.fr = true;
  this.aav = true;
  this.noResults = false;
}

parseDetails(str: string) {
  if(str.indexOf('^') !== -1) {
    return this.dealWithList(str);
  }
  else {
    return str;
  }

}

dealWithList(str: string): string {
  let newString = str.replace(/\^[\n\s]+?-\s+?/g, '<br> • ');
  return newString;
}

}



// WEBPACK FOOTER //
// ./src/providers/clinical-updates/clinical-updates.ts